import * as React from 'react';

import { Row, Col, Card, Breadcrumb, BreadcrumbItem, Button } from 'reactstrap';

// services
import {createItemGen, currentBaseUrl, currentLesson,currentUser, currentUserId, getGeneralSmartTableData, iconUrl, isUserLoggedIn, } from '../../common/services';

import Navbar from '../../components/CustomNav/CustomNav.Component';
import { Redirect } from 'react-router-dom';

// assets
import tutorData from '../../assets/data/sampleTutors';

// styling
import './chooseTutor.css';

import { CSSTransition } from 'react-transition-group'
// toast
import 'react-toastify/dist/ReactToastify.css';

// toast component
import { toast, ToastContainer} from 'react-toastify';

class ChooseTutor extends React.Component <{}, any>{
    public state = {
        baseUrl: currentBaseUrl(),
        currentselection: -1,
        currenttutor: {},
        tutors: [],
        destination: '',
        navigate: false,
        toLogin: false,
        toProfile: false,
        tutorfields: {
            id: 'UserProfileId',
            profile: 'Profiledata',
            name: 'name',
            description: 'description',
            avatar: 'avatar',
            tutorid: 'TutorId'
        }
    }

    constructor(props) {
        super(props);
        this.fillTutorItems = this.fillTutorItems.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
        this.openWidget = this.openWidget.bind(this);
        this.onLogout = this.onLogout.bind(this);
        this.onProfile = this.onProfile.bind(this);
        this.handleChecking = this.handleChecking.bind(this);
        this.handleGenSmartDataLoaded = this.handleGenSmartDataLoaded.bind(this);
        this.handleTutorClick = this.handleTutorClick.bind(this);
        this.handleRequestCompleted = this.handleRequestCompleted.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
    }

    public handleTutorClick = (selid, e) => {
        this.setState({currentselection: selid});
        console.log('clicked:' + selid)
        this.setState({currenttutor: this.state.tutors[selid]});

    }

    public handleGenSmartDataLoaded(key,objkey, res) {
        if(res.code ===200){
            console.log("THE KEY IS " + key);
            this.setState({loaded: true});
            this.setState({[key]: res.response[objkey]});
        }
        if(res.code ===401){
            this.onLogout('arg');
        }
    }

    public handleRequestCompleted(res) {
        if(res.code ===200){
            this.setState({navigate: true});
        }
        else{
            toast.error("Sorry, request failed");
        }
    }

    public onLogout(arg) {
        console.log('Logout in Parent', arg);
        this.setState({tologin: true});
    }

    public componentDidMount() {
        if(!isUserLoggedIn()) {
            this.setState({toLogin: true});
        }
        getGeneralSmartTableData( 'overview/tutors', text => this.handleGenSmartDataLoaded('tutors', 'tutors',text));
    }

    public handleChecking(id) {
        // handle checking and unchekcing
        toast.info("id" + id);
        this.setState(prevState => {
            const updatedTutors = prevState.tutors.map(tutor => {
                if(tutor.id === id) {
                    tutor.chosen = !tutor.chosen;
                }
                return tutor;
            });

            return {
                tutors: updatedTutors
            }
        });

    }

    public fillTutorItems() {
        if(this.state.tutors.length > 0) {
           return  (
               <div className="tutor-items-container">
                   {this.state.tutors.map((tutor, index) =>
                   <div className="tutor-item" key={tutor[this.state.tutorfields.id]}>
                        <div className="thumbnail">
                            <img onClick={this.handleTutorClick.bind(this, index)} src={iconUrl(tutor[this.state.tutorfields.profile][this.state.tutorfields.avatar])}  className="tutor-image"/>

                            <input type="checkbox"
                                readOnly={true}
                                className = "tutor-checkbox"
                                checked = {this.state.currentselection === index}
                                style = {{backgroundColor: "#ff0033"}}
                            />

                        </div>
                        <div className="tutor-details">
                            <h2 className="tutor-name">{tutor[this.state.tutorfields.profile][this.state.tutorfields.name]}</h2>
                            <p className="tutor-descript">{tutor[this.state.tutorfields.profile][this.state.tutorfields.description]}</p>
                        </div>
                    </div>)}
               </div>

           )
        }else {
            return(
                <p>No tutors available</p>
            )
        }
    }

    public handleItemClick() {
        if (this.state.currentselection === -1) {
            toast.info("choose tutor first!")
            return;
        }
        const allockey = 'id';
        const profkey = "UserProfileId"
        // ideally POST changes back to end point before routing back to lesson
        const item = {
            Tutor: this.state.currenttutor[profkey],
            LessonAllocation: currentLesson()[allockey]
        }

        console.log(item);

        console.log(this.state.currenttutor);

        createItemGen( 'lesson_allocations/'+ currentLesson()[allockey] + '/tutor_select/', item, text => this.handleRequestCompleted(text));
    }

    public openWidget(param) {
        this.setState({navigate: true})
    }


    public onProfile() {
        this.setState({toProfile: true})
    }
    public render() {
        if(this.state.toLogin) {
            return <Redirect to="/login"/>
        }
        if(this.state.toProfile) {
            return <Redirect to={this.state.baseUrl + "profile"} />
        }
        if(this.state.navigate) {
            const lessonidkey = "LessonId"
            const path = this.state.baseUrl + 'lessonview/' + currentLesson()[lessonidkey]
            return <Redirect to={path}/>
        }
        return (
          <div>
            <Navbar
              logoutParent={this.onLogout}
              profileParent={this.onProfile}
            />
            <ToastContainer style={{ zIndex: 9999999 }} />
            <CSSTransition
              in={true}
              appear={true}
              classNames="fade"
              timeout={800}
            >
              <div className="tutors-container">
                <div style={{width: "80%", marginTop:"4em;"}}>
                  <p className="go-back" onClick={this.openWidget.bind(this, "home")}>{" "} &lt; Back{" "}</p>
                </div>
                <div className="tutors-header-content">
                  <h1 className="tutors-title">Choose a Tutor</h1>
                  <button
                    className="tutors-save green-button"
                    onClick={this.handleItemClick}
                  >
                    Save
                  </button>
                </div>
                {this.fillTutorItems()}
                <div
                  className="tutors-help"
                  style={{
                    width: "80%",
                    textAlign: "right",
                    marginTop: "2em"
                  }}
                >
                  <button className="red-button tutors-help-button">Help</button>
                </div>

              </div>
            </CSSTransition>
          </div>
        );
    }
}

export default ChooseTutor;


// WEBPACK FOOTER //
// ./src/pages/SingleLesson/chooseTutor.Component.tsx